// extracted by mini-css-extract-plugin
var _1 = "ChapterPathBackgroundHall__chapterPathBackgroundHall--Rbzjr";
var _2 = "ChapterPathBackgroundHall__img--vet1T ChapterPathStyles__antiSeams--XNFsH ChapterPathStyles__antiLag--A6PV1";
export { _1 as "chapterPathBackgroundHall", _2 as "img" }
